import React, { FC, Suspense } from 'react';
import type { ProductSidePanelProps } from './common/types';
import { ProductSidePanelContent } from './productSidePanelContent';
import { SidePanelSkeleton } from './common/sidePanelSkeleton';

const ProductSidePanel: FC<ProductSidePanelProps> = (props) => {
    return (
        <Suspense fallback={<SidePanelSkeleton onClose={props.onClose} />}>
            <ProductSidePanelContent {...props} />
        </Suspense>
    );
};

export default ProductSidePanel;
